import { ReactNode } from 'react'
import { clsx } from '@mantine/styles'

import classes from './Chip.module.scss'

type ChipProps = {
  label: string | ReactNode
  handleClick: VoidFunction
  disabled?: boolean
  testId?: string
  classNames?: string
}

export function Chip({ label, handleClick, disabled, testId, classNames }: ChipProps) {
  return (
    <button
      className={clsx(classes.Chip, classNames)}
      type="button"
      data-testid={testId}
      onClick={handleClick}
      disabled={disabled}
    >
      {label}
    </button>
  )
}
